import { Scanner } from "../scanner.js";
import { enclosingChar, enclosingQuote, parseEnclosed } from "./enclosed.js";
import { parseUnenclosed, writeMissingOperandMessage } from "./unenclosed.js";
export const parseOperand = (s) => s.scanner.lookahead === "" ? s.error(writeMissingOperandMessage(s))
    : s.scanner.lookahead === "(" ? s.shiftedByOne().reduceGroupOpen()
        : s.scanner.lookaheadIsIn(enclosingChar) ? parseEnclosed(s, s.scanner.shift())
            : s.scanner.lookaheadIsIn(Scanner.whiteSpaceTokens) ?
                parseOperand(s.shiftedByOne())
                : s.scanner.lookahead === "d" ?
                    s.scanner.nextLookahead in enclosingQuote ?
                        parseEnclosed(s, `${s.scanner.shift()}${s.scanner.shift()}`)
                        : parseUnenclosed(s)
                    : parseUnenclosed(s);
